import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=28268baa&scoped=true"
import script from "../script/services-script.js?vue&type=script&lang=js&external"
export * from "../script/services-script.js?vue&type=script&lang=js&external"
import style0 from "./Services.vue?vue&type=style&index=0&id=28268baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28268baa",
  null
  
)

export default component.exports